import { createSlice } from '@reduxjs/toolkit';



interface InitialState {
  allSitesLoaded: boolean;
  allSitesData: SiteData[];
}

const initialState: InitialState = {
  allSitesLoaded: false,
  allSitesData: [],
};
const allSitesLoaded = createSlice({
  name: "allSitesLoaded", // Use the same name as in your store configuration
  initialState,
  reducers: {
    setAllSitesLoaded: (state, action) => {
      state.allSitesLoaded = action.payload;
    },
    setAllSitesData: (state, action) => {
      state.allSitesData = action.payload;
    },
    updateSingleSitesData: (state, action) => {
      const data = action.payload || [];
      const siteData = [...(state.allSitesData || [])];
      if (siteData.length > 0) {
        const siteId = data[0]?.siteId;
        const index = siteData.findIndex(({ id }) => id === siteId);
        if (index > -1) {
          const tableColumnSettingsAllVOs = data.map(
            ({
              id,
              colName,
              colType,
              desktop,
              mobile,
              both,
              visible,
            }: TableColumnSettings) => ({
              id,
              colName,
              colType,
              visible: !!desktop || !!mobile || !!both || !!visible,
            })
          );
          siteData[index].tableColumnSettingsAllVOs =
            tableColumnSettingsAllVOs;
            siteData[index].sampleLocationAllVOs = state.allSitesData[
            index
          ].sampleLocationAllVOs.map((sampleLocation) => ({
            ...sampleLocation,
            dataPointAllVOs: sampleLocation.dataPointAllVOs.map(
              (dataPoint) => ({
                ...dataPoint,
                valueVOs: dataPoint.valueVOs.map((value) => {
                  const matchedColumn = tableColumnSettingsAllVOs.find(
                    (col: TableColumnSettingsAllVO) =>
                      col.colName === value.displayName ||
                      col.colName === value.outputId
                  );
                  return matchedColumn
                    ? { ...value, visible: matchedColumn.visible }
                    : value;
                }),
              })
            ),
          }));
          state.allSitesData = siteData;
          return state;
        }
      }
    },
    updateSingleSitesDataPoints: (state, action) => {
      const { siteId, id, outputs, notes, samplePointId, outputAlarm } =
        action.payload;

      const siteIndex = state.allSitesData.findIndex(
        (site) => site.id === siteId
      );
      if (siteIndex === -1) return state; // If site not found, do nothing

      const site = state.allSitesData[siteIndex];
      const locationIndex = site.sampleLocationAllVOs.findIndex(
        (sl) => sl.id === samplePointId
      );
      if (locationIndex === -1) return state; // If sample location not found, do nothing
      const dataPointIndex = site.sampleLocationAllVOs[
        locationIndex
      ].dataPointAllVOs.findIndex((dp) => dp.id === id);
      if (dataPointIndex === -1) return state; // If data point not found, do nothing

      // Update the note for the specific data point
      const dataPoint = site.sampleLocationAllVOs[locationIndex].dataPointAllVOs[dataPointIndex];
      dataPoint.note = notes; // Update the note
      dataPoint.valueVOs.forEach((value) => {
        if (outputs.hasOwnProperty(value.outputId)) {
          value.outputValue = outputs[value.outputId]; // Update the outputValue using the outputs from the payload
          value.outputAlarm = outputAlarm[value.outputId] ?? value.outputAlarm;
        }
      });
      return state;
    },
    updateSingleSite: (state, action) => {
      const sampleLocationAllVOs = action.payload.updatedSampleLocations;
      const siteId = action.payload.siteId;
      const allSitesData  = [...(state.allSitesData || [])]
      const index = state.allSitesData.findIndex((site) => siteId === site.id);
      if (index !== -1) {
        allSitesData[index] = {
          ...allSitesData[index],
          sampleLocationAllVOs,
        };
        state.allSitesData = allSitesData
      }
      return state
    },

    deleteSingleSiteDatapoints: (state, action) => {
      const { siteId, samplePointId, dataPointId } = action.payload;
      const siteIndex = state.allSitesData.findIndex(site => site.id === siteId);
      if (siteIndex === -1) return state; 
      const site = state.allSitesData[siteIndex];
      const locationIndex = site.sampleLocationAllVOs.findIndex(sl => sl.id === samplePointId);
      if (locationIndex === -1) return state;
      const updatedDataPoints = site.sampleLocationAllVOs[locationIndex].dataPointAllVOs.filter(
        dp => dp.id !== dataPointId
      );
      site.sampleLocationAllVOs[locationIndex].dataPointAllVOs = updatedDataPoints;
      state.allSitesData = [...state.allSitesData];
    }, 
  },
});

export const { setAllSitesLoaded, setAllSitesData, updateSingleSitesData,updateSingleSite,updateSingleSitesDataPoints, deleteSingleSiteDatapoints } =
  allSitesLoaded.actions;
export default allSitesLoaded.reducer;
